import { IListFetcher } from '../fetchers/IListFetcher';
import { ListResult } from '../fetchers/ListResult';
import { IGetItemsParams } from '../ServerApi/types/IGetItemsParams';
import { ISliceable } from './ISliceable';

export class PagedList<T> implements ISliceable<T> {

  private fetcher: IListFetcher<T>;
  private fetchParams: IGetItemsParams;

  constructor(fetcher: IListFetcher<T>, fetchParams: IGetItemsParams) {
    this.fetcher = fetcher;
    this.fetchParams = fetchParams;
  }

  public getSlice(start: number, size: number): ng.IPromise<ListResult<T>> {
    return this.fetchItems({
      filter: this.fetchParams.filter,
      order: this.fetchParams.order,
      page: {
        startIndex: start,
        maxItems: size
      }
    });
  }

  private fetchItems(params: IGetItemsParams): ng.IPromise<ListResult<T>> {
    return this.fetcher.fetchList(params).then((result: ListResult<T>) => {
      if (result) {
        this.fetchParams = params;
      }
      return result;
    });
  }

}
